"use client";

import StatusNotice from "@/components/ui/StatusNotice";
import { BluetoothOff } from "@/components/ui/icons";
import type { AppleMusicErrorTone } from "@/lib/appleMusicAuth";

type LoginNoticesProps = {
  authError: string | null;
  appleLoginError: string | null;
  appleLoginErrorTone: AppleMusicErrorTone;
  azureError: string | null;
  participantGateTriggered: boolean;
  participantGateMessage: string;
  isAppleLinkFlow: boolean;
};

export function LoginNotices({
  authError,
  appleLoginError,
  appleLoginErrorTone,
  azureError,
  participantGateTriggered,
  participantGateMessage,
  isAppleLinkFlow,
}: LoginNoticesProps) {
  const appleTone =
    appleLoginErrorTone === "warn"
      ? "warning"
      : appleLoginErrorTone === "info"
        ? "info"
        : "error";

  return (
    <>
      {authError ? (
        <StatusNotice tone="error" layout="bar" className="text-left">
          {authError}
        </StatusNotice>
      ) : null}

      {appleLoginError ? (
        <StatusNotice
          tone={appleTone}
          layout="bar"
          className="mt-3 text-left"
        >
          {appleLoginError}
        </StatusNotice>
      ) : null}

      {azureError ? (
        <StatusNotice
          tone="warning"
          layout="bar"
          className="mt-3 text-left"
        >
          {azureError}
        </StatusNotice>
      ) : null}

      {participantGateTriggered ? (
        <StatusNotice
          tone="info"
          layout="panel"
          title="Participant Sessions"
          icon={
            <BluetoothOff
              className={"h-[1.125rem] w-[1.125rem]"}
              aria-hidden="true"
            />
          }
          className="mt-[0.85rem] text-left"
        >
          <p className="theme-copy-soft text-[0.75rem] leading-[1.6] 2xl:text-[0.9375rem]">
            {participantGateMessage}
          </p>
        </StatusNotice>
      ) : null}

      {isAppleLinkFlow ? (
        <StatusNotice
          tone="info"
          layout="bar"
          className="mt-3 text-left"
        >
          Apple Music shared account link mode: use the Apple Music
          button below to link this account.
        </StatusNotice>
      ) : null}
    </>
  );
}
